import React from 'react'
import { Router, Route } from 'react-router'
import MainContainer from 'containers/Main'
import routes from './routes.js'
import { connect } from 'react-redux';
export let routesObj = {};

function generateRoutes(routes) {
  return routes.items.map((r) => {
    let component = require(`containers/pages/${r.component}`)
    routesObj[r.path] = r;
    return <Route key={r.path} path={r.path} component={component}/>
  });
}

const mapStateToProps = state => ({
  user: state.user,
  subscription: state.gSubscription.result || {},
});

class Routes extends React.Component {
  constructor(opts) {
    super(opts);

    this.onRouteChange = this.onRouteChange.bind(this);
  
    // const currentLocation = window.location; 
  
    // this.checkIfRedirectNeeded(currentLocation);
  }

  onRouteChange(e) {
    //this.checkIfRedirectNeeded(e.location);
    if (global['--classtop-main-section']) {
      global['--classtop-main-section'].scrollTo(0, 0);
    }  
  }


  // Not sure why we need this, this is causing some errors on change school page --Billy
  checkIfRedirectNeeded({ pathname }) {
    // const {is_valid, maximum_amount} = this.props.subscription;
    // if (pathname !== '/') {
    //   if (!localStorage.getItem('schoolId')) {
    //     browserHistory.push('/');
    //   }
    // }
    // if(is_valid && maximum_amount.maximum_school!==0){
    //   if(pathname !== '/' || pathname !== '/account-settings'){
    //     //browserHistory.push('/');
    //   }
    // }
  }

  render() {
    return (
      <Router history={this.props.history}>
        <Route component={MainContainer} onEnter={this.onRouteChange} onChange={this.onRouteChange}>
          {generateRoutes(routes)}
        </Route>
      </Router>
    )
  }
}

export default connect(mapStateToProps)(Routes)



// WEBPACK FOOTER //
// ./src/routes/index.js